/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfListOfOperationalFileTypeDto } from "../models/AjaxResponseOfListOfOperationalFileTypeDto";
import type { AjaxResponseOfOperationalFileTypeDto } from "../models/AjaxResponseOfOperationalFileTypeDto";
import type { CreateOrUpdateOperationalFileTypeDto } from "../models/CreateOrUpdateOperationalFileTypeDto";
import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";
export class OperationalFileTypesAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @returns AjaxResponseOfListOfOperationalFileTypeDto Success
   * @throws ApiError
   */
  public getAll({
    targetScope,
  }: {
    targetScope?: string;
  }): CancelablePromise<AjaxResponseOfListOfOperationalFileTypeDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/operational/file-types",
      query: {
        targetScope: targetScope,
      },
    });
  }
  /**
   * @returns AjaxResponseOfOperationalFileTypeDto Success
   * @throws ApiError
   */
  public create({
    requestBody,
  }: {
    requestBody?: CreateOrUpdateOperationalFileTypeDto;
  }): CancelablePromise<AjaxResponseOfOperationalFileTypeDto> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/operational/file-types",
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * @returns any Success
   * @throws ApiError
   */
  public delete({
    fileTypeId,
  }: {
    fileTypeId: number;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/api/front-end/v1/operational/file-types/{fileTypeId}",
      path: {
        fileTypeId: fileTypeId,
      },
    });
  }
  /**
   * @returns AjaxResponseOfOperationalFileTypeDto Success
   * @throws ApiError
   */
  public update({
    fileTypeId,
    requestBody,
  }: {
    fileTypeId: number;
    requestBody?: CreateOrUpdateOperationalFileTypeDto;
  }): CancelablePromise<AjaxResponseOfOperationalFileTypeDto> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/api/front-end/v1/operational/file-types/{fileTypeId}",
      path: {
        fileTypeId: fileTypeId,
      },
      body: requestBody,
      mediaType: "application/json",
    });
  }
}
